import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/zh' },
  {
    path: '/:lang(zh|en)', component: () => import('../views/SiteLayout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('../views/Home.vue') },
      { path: 'login', name: 'Login', component: () => import('../views/Login.vue') },
      { path: 'section/:key', name: 'Section', component: () => import('../views/Section.vue') },
      { path: 'history', name: 'History', component: () => import('../views/HistoryPage.vue') },
      { path: 'history/:id', name: 'HistoryDetail', component: () => import('../views/HistoryDetail.vue') },
      { path: 'sub-item/:key/:id', name: 'SubItem', component: () => import('../views/SubItemDetail.vue') },
      { path: 'sub-column/:key/:id', name: 'SubColumn', component: () => import('../views/SubColumnPage.vue') },
      { path: 'category/:slug', name: 'Category', component: () => import('../views/Category.vue') },
      { path: 'article/:slug', name: 'Article', component: () => import('../views/Article.vue') },
      // 会议发布：列表页展示全部发布条目，详情页按条目下标展示单条完整内容
      { path: 'news', name: 'NewsList', component: () => import('../views/NewsList.vue') },
      { path: 'news/:id', name: 'NewsDetail', component: () => import('../views/NewsDetail.vue') },
      // 专题会议：以新闻列表方式展示全部专题及各自详细内容
      { path: 'topics', name: 'TopicsList', component: () => import('../views/TopicsList.vue') },
      // 会议日程图片展示
      { path: 'schedule-gallery', name: 'ScheduleGallery', component: () => import('../views/ScheduleGallery.vue') },
    ]
  }
]

// 滚动位置交由 Vue Router + keep-alive activated 手动管理，禁用浏览器原生恢复，避免与 restoreScroll 抢占导致首页回到顶部
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

const router = new VueRouter({
  routes,
  scrollBehavior() {
    // 首页：由 keep-alive activated + restoreScroll 恢复离开前位置
    // 其他页面：由 afterEach 延迟滚动，确保新页面渲染后再 scrollTo，不在旧页面上滚动
    return undefined
  }
})

// 路由切换后延迟滚动到新页面顶部：
// setTimeout 给新组件足够时间完成数据加载和 DOM 渲染，避免在旧页面上滚动
router.afterEach((to) => {
  if (to.name === 'Home') return
  setTimeout(() => window.scrollTo(0, 0), 50)
})

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || 'zh'
  i18n.locale = lang
  document.documentElement.lang = lang
  next()
})

export default router
